<template>
    <page>
        <module :title="title" enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="团长信息" name="chief_info"  placeholder="匹配昵称、手机号"></c-form-item>
                    <c-form-item type="input" label="商品规格" name="product_info" placeholder="匹配名称、规格"></c-form-item>
                    <c-form-item type="datetime" date-type="datetime" label="开团时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="checkbox" label="成团状态" name="achieve_state" :options="achieveState"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="table">

                <c-table-column
                        label="成团状态"
                        name="achieve_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.achieve_state == -1" style="color:gray">未开团</span>
                        <span v-if="data.achieve_state == 0" style="color:brown">待成团</span>
                        <span v-if="data.achieve_state == 1" style="color:forestgreen">已成团</span>
                        <span v-if="data.achieve_state == 2" style="color:red">成团失败</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="300"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="团购价"
                >
                    <template v-slot="{data}">
                        ￥{{parseFloat(data.product_order_price).toFixed(2)}}
                        <font style="text-decoration: line-through;color:#999999;" v-if="data.product_order_price!=data.original_sale_price">
                            <br/>
                            ￥
                            {{parseFloat(data.original_sale_price).toFixed(2)}}
                        </font>
                    </template>
                </c-table-column>

                <c-table-column
                        label="团长"
                        name="head_photo"
                        width="200"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                            <span v-if="data.user_manage_mobilephone">({{data.user_manage_mobilephone}})</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                    label="成团人数"
                    name="min_group_count"
                    width="80"
                >
                    <template v-slot="{data}">
                        <b>{{data.min_group_count}}</b>人团
                    </template>
                </c-table-column>

                <c-table-column
                    label="参团人数"
                    name="joined_count"
                    width="80"
                >
                </c-table-column>

                <c-table-column
                        label="开团时间"
                        width="150"
                >
                    <template v-slot="{data}">
                        <span v-if="data.create_date">{{data.create_date}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="成团时间"
                        width="150"
                >
                    <template v-slot="{data}">
                        <span v-if="data.achieve_state==1 && data.achieve_date">{{data.achieve_date}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>


                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="140"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="showOrderList(data)">拼团订单</c-table-button>
                        <c-table-button v-if="data.achieve_state == 0 && data.chief_payment_state == 3" @click="achieveGroupActivity(data)">手动成团</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
        <!--展示订单列表-->
        <pop-order-list ref="popOrderList"></pop-order-list>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import popOrderList from '@/components/service/pop_order_list.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'activity_group_approve',

        props: {
            id: String
        },

        components: {
            popOrderList,
            productInfo
        },

        data() {
            return {
                title:'',
                achieveState: [
                       { name: '未开团',value: -1},
                       { name: '待成团',value: 0},
                       { name: '已成团',value: 1},
                       { name: '成团失败',value: 2}
                ]
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
                this.searchHandle({});
            }
        },

        mounted() {
            this.getActivityDetail();
            this.searchHandle({});
        },

        methods: {
            searchHandle(data) {
                if (!data){
                    data = {};
                }
                data.group_activity_id = this.id;//拼团活动主表ID
                this.$refs.table.load({
                    url: '/activity/group/initiate/list',
                    data
                });
            },

            getActivityDetail() {
                this.request({
                    url: '/activity/group/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.title = "拼团活动【"+data.activity_name+"】成团审批";
                    }
                });
            },

            /**
             * 手动成团
             * */
            achieveGroupActivity(data) {
                var nick_name = data.nick_name||'--';
                var user_manage_mobilephone = data.user_manage_mobilephone||'--';
                var text = "是否确定将团长【"+nick_name+'/'+user_manage_mobilephone;
                text+="】发起的拼团活动设置为：【已成团】；成团后，将不再允许其他会员参团，请谨慎操作";
                this.$confirm({
                    text: text,
                    resolve: () => {
                        this.request({
                            url: '/activity/group/initiate/achieve',
                            data: {
                                id: data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '手动成团成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            /***
             查看拼团订单列表
             **/
            showOrderList(data){
                this.$refs.popOrderList.open({
                    group_activity_share_id:data.id,
                    order_type:[8]
                });
            }
        }
    }
</script>